export class UserClientDto {
    id: number
    clientId: number | null
    username: string
    objectUuid: string
}